import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import user from "./modules/user";
import app from "./modules/app";
import page from "./modules/page";

import getters from "./getters";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: localStorage,
  modules: ['user', 'app'],
  restoreState: (key, storage) => {
    try {
      const savedState = JSON.parse(storage.getItem(key) || '{}');
      delete savedState.page;
      return savedState;
    } catch (error) {
      return {};
    }
  },
});

export default new Vuex.Store({
  modules: {
    user,
    app,
    page,
  },
  getters,
  plugins: [vuexLocal.plugin],
});
